import { SET_PROFILE, REQUEST_PROFILE_READ, RECEIVE_PROFILE_READ, RECEIVE_MEMBERS ,initialState} from "../actions/profile";

export const setProfileData = (data) => ({ type: SET_PROFILE, data });
export const setProfileMembers = (data) => ({ type: RECEIVE_MEMBERS, data });

function reducer(state = initialState, action = {}) {
  
  switch (action.type) {
    case REQUEST_PROFILE_READ:    
      return { ...state, isFetching: true };
    case SET_PROFILE:      
      return {
        ...state,
        ... action.data.profile
      };
      break;
    case RECEIVE_PROFILE_READ:      
      const members = action.members
      return {
        ...state,
        members,
        isFetching: false 
      };
    case RECEIVE_MEMBERS:      
      const membersData = action.data;
      return {
        ...state,
        members: membersData,
        isFetching: false
      };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/profile.js